module.exports = __webpack_public_path__ + "img/12.0469271b.png";